<template>
  <div class="deck-deeplink-container">
    <page-header :show-breadcrumbs="false">
      <template #topbar>
        <h1>{{ deck.title }}</h1>
      </template>
    </page-header>
    <div
      v-if="!loading"
      class="list-container tabbed"
    >
      <template v-for="card in cards" :key="card.id">
        <component
          :is="card.listRowType"
          :card="card"
          @row-clicked="cardClicked"
        />
      </template>
    </div>
  </div>
</template>

<script>
import PageHeader from '@components/singletons/pageHeader';
import AttachmentListRow from '@components/attachments/listRow';
import DeckListRow from '@components/decks/cardListRow';
import GroupingListRow from '@components/groupings/listRow';
import LearningModuleListRow from '@components/learningModules/listRow';
import TopicListRow from '@components/topics/listRow';

import CardMixin from '@/mixins/card';
import GlobalMixin from '@/mixins/global';

export default {
  components: { AttachmentListRow, DeckListRow, GroupingListRow, LearningModuleListRow, PageHeader, TopicListRow },
  mixins: [CardMixin, GlobalMixin],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    cards() {
      if (this.deck) {
        // Spread into it's own array to prevent modifying the original
        return [...this.deck.cards].sort((a, b) => a.order - b.order);
      } else {
        return [];
      }
    },
    deck() {
      return this.$store.getters['decks/get'][this.$route.params.deckId];
    },
  },
  mounted() {
    this.$store.dispatch('flashcardStates/fetchStates', ['attachments', 'bookmarks', 'flashcards', 'topics']);
    this.deck.fetchAssets(this.$store).then(() => {
      this.loading = false;
      if (this.$route.query?.card) {
        const card = this.cards.find(c => c.id === Number(this.$route.query.card));
        if (card.isAttachmentCard) {
            this.openCard(card);
        }
        this.$nextTick().then(() => {
          const { query, ...routeSansQuery } = this.$route;
          this.$router.replace(routeSansQuery);
        });
      }
    });
  },
  methods: {
    cardClicked(card) {
      this.$analytics.events.viewedCard(card, this.deck);
      this.openCard(card);
    },
  },
};
</script>

<style lang='scss' scoped>
.deck-deeplink-container {
  background: #EDF1F5;
  margin-top: rem-calc(64) !important;
}
</style>
